/* eslint max-classes-per-file: 0 */
/* eslint class-methods-use-this: 0 */

import {
  UserParticipantsCollection,
} from '@/typings/api/User'

import { Fabric } from '@/store/createCrudModule'
import { UsersParticipantsAdapter } from './UsersParticipantsAdapter'


export const fabric = Fabric<UserParticipantsCollection, UserParticipantsCollection>()

type S = UsersParticipantsState
type G = UsersParticipantsGetters
type M = UsersParticipantsMutations
type A = UsersParticipantsActions


export class UsersParticipantsState extends fabric.State {
}

export class UsersParticipantsGetters extends fabric.Getters<S> {
}

export class UsersParticipantsMutations extends fabric.Mutations<S> {
}

export class UsersParticipantsActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new UsersParticipantsAdapter();

  protected readonly idName = 'id';
}
